document.addEventListener('DOMContentLoaded', function () {
    const dropdownTrigger = document.getElementById('dropdown-trigger');
    const dropdownMenu = document.getElementById('dropdown-menu');
    const dropdownItems = document.querySelectorAll('.dropdown-item');
    const mainItemText = document.getElementById('main-item-text');

    dropdownTrigger.addEventListener('click', function (event) {
      event.preventDefault();
      dropdownMenu.classList.toggle('tw-hidden');
    });

    dropdownItems.forEach((item) => {
      item.addEventListener('click', function (event) {
        event.preventDefault();

        const selectedItemText = item.innerHTML;
        const selectedItemLink = item.getAttribute('href');
        mainItemText.innerHTML = selectedItemText;

        const mainItemLink = document.querySelector('#main-item-link');
        mainItemLink.setAttribute('href', selectedItemLink);
        dropdownMenu.classList.add('tw-hidden');
        window.location.href = selectedItemLink;
    });
  });
});
